import React, { useMemo } from "react";
import { createAvatar } from "@dicebear/core";
import { micah, avataaars, bottts, funEmoji, lorelei, notionists } from "@dicebear/collection";

const stylesMap = {
  micah,
  avataaars,
  bottts,
  funEmoji,
  lorelei,
  notionists
};

const Avatar = ({ avatarData, seedFallback = "default", size = 40, className = "", style = {} }) => {
  const renderedAvatar = useMemo(() => {
    // 1. Boş veya tanımsızsa, varsayılan bir DiceBear avatarı oluştur
    if (!avatarData) {
      const avatar = createAvatar(micah, { seed: seedFallback });
      return <img src={avatar.toDataUri()} alt="Avatar" style={{ width: "100%", height: "100%", objectFit: "cover" }} />;
    }

    // 2. String kontrolü
    if (typeof avatarData === "string") {
      // Dış URL (ReadyPlayerMe veya Yüklenen Resim)
      if (avatarData.startsWith("http") || avatarData.startsWith("data:") || avatarData.startsWith("/")) {
        return <img src={avatarData} alt="Avatar" style={{ width: "100%", height: "100%", objectFit: "cover" }} />;
      }
      
      // JSON formatı kontrolü (Eski format veya Yeni DiceBear formatı)
      if (avatarData.trim().startsWith("{")) {
        try {
          const parsed = JSON.parse(avatarData);
          
          // Yeni Sistem DiceBear Formatı: { type: 'dicebear', style: 'micah', seed: 'emre' }
          if (parsed.type === "dicebear" && parsed.style && stylesMap[parsed.style]) {
            const avatar = createAvatar(stylesMap[parsed.style], { seed: parsed.seed || seedFallback });
            return <img src={avatar.toDataUri()} alt="Avatar" style={{ width: "100%", height: "100%", objectFit: "cover" }} />;
          }

          // Eski Format (Hatalı veya legacy, örneğin: {"part":"31","theme":"C"})
          // Fallback olarak ismiyle DiceBear oluştur
          const avatar = createAvatar(micah, { seed: seedFallback });
          return <img src={avatar.toDataUri()} alt="Avatar" style={{ width: "100%", height: "100%", objectFit: "cover" }} />;
        } catch (e) {
          // JSON Parse hatası, varsayılana dön
          const avatar = createAvatar(micah, { seed: seedFallback });
          return <img src={avatar.toDataUri()} alt="Avatar" style={{ width: "100%", height: "100%", objectFit: "cover" }} />;
        }
      }

      // Sadece Emoji (Uzunluğu 10 karakterden küçükse)
      if (avatarData.length <= 10) {
        return <div style={{ fontSize: `${size * 0.6}px`, display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', height: '100%' }}>{avatarData}</div>;
      }

      // Fallback
      const avatar = createAvatar(micah, { seed: avatarData });
      return <img src={avatar.toDataUri()} alt="Avatar" style={{ width: "100%", height: "100%", objectFit: "cover" }} />;
    }

    // Bilinmeyen format
    const avatar = createAvatar(micah, { seed: seedFallback });
    return <img src={avatar.toDataUri()} alt="Avatar" style={{ width: "100%", height: "100%", objectFit: "cover" }} />;
  }, [avatarData, seedFallback, size]);

  return (
    <div
      className={`custom-avatar ${className}`}
      style={{
        width: size,
        height: size,
        borderRadius: "50%",
        overflow: "hidden",
        backgroundColor: "var(--bg-surface, rgba(255,255,255,0.1))",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
        ...style,
      }}
    >
      {renderedAvatar}
    </div>
  );
};

export default Avatar;